import { BiArrowBack } from 'react-icons/bi'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomerDetail from './CustomerDetail'
import Verification from './Verification'
import classNames from 'classnames'
import Posts from './posts/Posts'
import BuyItemList from './buyItems/BuyItemList'
import SoldItemList from './soldItems/SoldItemList'
import NewItemSell from './newitemSell/requestManager'
import FollowingAndFollwers from './FollowingAndFollwers'
import LastUpdatedOn from './LastUpdatedOn'
import apiPath from 'utils/apiPath'
import { apiGet } from 'utils/apiFetch'
import AuthContext from 'context/AuthContext'


const tabBtnClass =
  'inline-block py-3 px-3 xl:px-4 2xl:px-6 text-sm font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_CUSTOMER_DETAIL = 'customer_detail'
const TAB_VERIFICATION = 'verification'
const TAB_POSTS = 'posts'
const TAB_BUY_ITEM_LIST = 'buy_item_list'
const TAB_SOLD_ITEM_LIST = 'sold_item_list'
const TAB_NEW_ITEM_SELL = 'new_item_sell'
const TAB_FOLLOWING_AND_FOLLOWERS = 'following_and_followers'
const TAB_UPDATED_ON = 'update_on'

function CustomerViewPage () {
  const { updatePageName } = useContext(AuthContext)
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
  }
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const [defaultTab, setDefaultTab] = useState(location.state?.from === 'posts' ? 'posts' : location.state?.from === 'sold_item_list' ? 'sold_item_list' : location.state?.from === 'buy_item_list' ? 'buy_item_list' : location.state?.from === 'new_item_sell' ? 'new_item_sell' : 'customer_detail')
  const [item, setItem] = useState({})

  const getUserDetails = async (itemId) => {
    try {
      const path = apiPath.userDetailsById + "/" + itemId ;
      const result = await apiGet(path);
      if (result?.status === 200) {
        const response = result?.data?.results;
        setItem(response);
      }
    } catch (error) {
      console.log("error ", error);
    }
  };

  useEffect(() => {
    updatePageName(t("O_USERS"))
    if(id){
      getUserDetails(id)
    }
    // getUserDetails(id)
  }, [id])

  return (
    <>
      <div className='p-10 py-2 pt-4'>
        <div className='flex border-b mb-4'>
          <span
            className='flex  items-center cursor-pointer'
            onClick={() => navigate('/users')}
          >
            <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2' />
            <span className='ml-2'>{t('O_BACK')}</span>
          </span>

          <div className='overflow-x-auto'>
            <ul className='flex'>
              <li className='mr-0 xl:mr-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_CUSTOMER_DETAIL)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_CUSTOMER_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_CUSTOMER_DETAIL
                  })}
                >
                  {t('O_PERSONAL_DETAILS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_VERIFICATION)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_VERIFICATION,
                    [tabBorderNoneClass]: defaultTab !== TAB_VERIFICATION
                  })}
                >
                  {t('O_VERIFICATION')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_POSTS)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_POSTS,
                    [tabBorderNoneClass]: defaultTab !== TAB_POSTS
                  })}
                >
                  {t('O_POSTS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_BUY_ITEM_LIST)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_BUY_ITEM_LIST,
                    [tabBorderNoneClass]: defaultTab !== TAB_BUY_ITEM_LIST
                  })}
                >
                  {t('O_BUYS_ITEM_LIST')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_SOLD_ITEM_LIST)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_SOLD_ITEM_LIST,
                    [tabBorderNoneClass]: defaultTab !== TAB_SOLD_ITEM_LIST
                  })}
                >
                  {t('O_SOLD_ITEM_LIST')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_NEW_ITEM_SELL)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_NEW_ITEM_SELL,
                    [tabBorderNoneClass]: defaultTab !== TAB_NEW_ITEM_SELL
                  })}
                >
                  {t('O_NEW_ITEM_SELL')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_FOLLOWING_AND_FOLLOWERS)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_FOLLOWING_AND_FOLLOWERS,
                    [tabBorderNoneClass]: defaultTab !== TAB_FOLLOWING_AND_FOLLOWERS
                  })}
                >
                  {t('O_FOLLOWING_AND_FOLLOWERS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_UPDATED_ON)}
                  className={classNames('h-full whitespace-nowrap',{
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_UPDATED_ON,
                    [tabBorderNoneClass]: defaultTab !== TAB_UPDATED_ON
                  })}
                >
                  {t('O_LAST_UPDATED_ON')}
                </button>
              </li>
            </ul>
          </div>
        </div>
        {defaultTab === TAB_CUSTOMER_DETAIL ? (
          <CustomerDetail userDetails={item} />
        ) : defaultTab === TAB_VERIFICATION ? (
          <Verification item={item} getUserDetails = {getUserDetails} />
        ) : defaultTab === TAB_POSTS ? (
          <Posts userDetails={item} />
        ) : defaultTab === TAB_BUY_ITEM_LIST ? (
          <BuyItemList userDetails={item} />
        ) : defaultTab === TAB_SOLD_ITEM_LIST ? (
          <SoldItemList userDetails={item} />
        ) : defaultTab === TAB_NEW_ITEM_SELL ? (
          <NewItemSell userDetails={item} />
        ) : defaultTab === TAB_FOLLOWING_AND_FOLLOWERS ? (
          <FollowingAndFollwers userDetails={item} />
        ) : defaultTab === TAB_UPDATED_ON ? (
          <LastUpdatedOn userDetails={item} />
        ) : null}
      </div>
    </>
  )
}

export default CustomerViewPage
